import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { GroupList } from '../components/GroupList';
import { Search } from 'lucide-react';

export const DayPage = () => {
    const { dayId } = useParams();
    const navigate = useNavigate();
    const { getDayGroups, days, userRole } = useApp();
    const [viewMode, setViewMode] = useState('grid');
    const [searchQuery, setSearchQuery] = useState('');

    const dayIndex = parseInt(dayId || '0');
    const groups = getDayGroups(dayIndex);
    const dayInfo = days[dayIndex];

    if (!dayInfo) return <div className="text-center p-8 text-xl text-slate-400">День не найден</div>;

    const dateStr = dayInfo.date.toLocaleDateString('ru-RU', {
        weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'
    });

    const filteredGroups = groups.filter(group =>
        group.name.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
        <div className="animate-fade-in">
            <div className="flex flex-col md:flex-row justify-between items-center mb-8 gap-4">
                <div className="flex items-center gap-4 w-full md:w-auto">
                    {userRole !== 'worker' && (
                        <button className="px-4 py-2 bg-slate-800 hover:bg-slate-700 text-slate-300 rounded-lg transition-colors border border-white/10" onClick={() => navigate('/')}>
                            ← Назад
                        </button>
                    )}
                    <h2 className="text-2xl font-bold text-white m-0">
                        {dateStr}
                    </h2>
                </div>

                <div className="flex gap-2 p-1 bg-slate-800/50 rounded-lg border border-white/10">
                    <button
                        className={`w-9 h-9 flex items-center justify-center rounded transition-all text-lg ${viewMode === 'grid' ? 'bg-indigo-600 text-white shadow-sm' : 'text-slate-400 hover:bg-white/5'}`}
                        onClick={() => setViewMode('grid')}
                        title="Grid"
                    >
                        ⊞
                    </button>
                    <button
                        className={`w-9 h-9 flex items-center justify-center rounded transition-all text-lg ${viewMode === 'list' ? 'bg-indigo-600 text-white shadow-sm' : 'text-slate-400 hover:bg-white/5'}`}
                        onClick={() => setViewMode('list')}
                        title="List"
                    >
                        ☰
                    </button>
                </div>
            </div>

            {/* Поле поиска */}
            <div className="relative mb-6">
                <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500" size={20} />
                <input
                    type="text"
                    placeholder="Поиск группы по названию..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="w-full bg-slate-900/50 border border-white/5 rounded-2xl py-4 pl-12 pr-4 text-white placeholder:text-slate-600 focus:outline-none focus:ring-2 focus:ring-indigo-500/50 transition-all"
                />
            </div>

            {filteredGroups.length === 0 ? (
                <div className="bg-slate-900/30 backdrop-blur-md border border-white/5 rounded-[32px] p-20 text-center text-slate-500">
                    <Search size={48} className="mx-auto mb-4 opacity-20" />
                    <p className="text-lg">Группы не найдены</p>
                    <p className="text-sm">Попробуйте изменить запрос</p>
                </div>
            ) : (
                <GroupList
                    groups={filteredGroups}
                    onGroupClick={(group) => navigate(`/group/${group.id}`)}
                    viewMode={viewMode}
                />
            )}
        </div>
    );
};

